import allStatus from "@/views/status/orderStatus";
export default {
  data() {
    return {
      statusOfOrder: allStatus,
    };
  },
  computed: {},
  methods: {
    returnOrderStatus(status) {
      if (status == this.statusOfOrder.saved) {
        return "statusSaved";
      } else if (status == this.statusOfOrder.sent) {
        return "statusSent";
      } else if (status == this.statusOfOrder.underway) {
        return "statusUnderWay";
      } else if (status == this.statusOfOrder.withCaptain) {
        return "statusWithCaptain";
      } else if (status == this.statusOfOrder.returnedWithCompany) {
        return "statusReturnedWithCompany";
      } else if (status == this.statusOfOrder.returnedWithClient) {
        return "statusReturnedWithClient";
      } else if (status == this.statusOfOrder.given) {
        return "statusGiven";
      } else if (status == this.statusOfOrder.wallet) {
        return "statusWallet";
      } else if (status == this.statusOfOrder.deleted) {
        return "statusDeleted";
      } else if (status == this.statusOfOrder.resend) {
        return "statusResend";
      } else if (status == this.statusOfOrder.missing) {
        return "statusMissing";
      } else if (status == this.statusOfOrder.expiredReturn) {
        return "statusExpiredReturn";
      } else if (status == this.statusOfOrder.delayed) {
        return "statusDelayed";
      } else if (status == this.statusOfOrder.ToCaptain) {
        return "statusToCaptain";
      } else if (status == this.statusOfOrder.ReturnedWithCaptain) {
        return "statusReturnedWithCaptain";
      } else if (status == this.statusOfOrder.ToBranch) {
        return "statusToBranch";
      } else if (status == this.statusOfOrder.InBranch) {
        return "statusInBranch";
      } else if (status == this.statusOfOrder.ReturnedToBranch) {
        return "statusReturnedToBranch";
      } else if (status == this.statusOfOrder.ReturnedInBranch) {
        return "statusReturnedInBranch";
      } else if (status == this.statusOfOrder.AssignedWithCaptain) {
        return "statusAssignedWithCaptain";
      } else if (status == this.statusOfOrder.ReturnedAssignedToMission) {
        return "statusReturnedAssignedToMission";
      }
    },
  },
  created() {},
};
